import { useState } from 'react';

/**
 * Image with a warm, on-brand gradient fallback. If the stock URL fails
 * (or while swapping to real photography), the slot stays elegant instead
 * of showing a broken image.
 */
export function Photo({
  src,
  alt,
  className = '',
  imgClassName = '',
}: {
  src: string;
  alt: string;
  className?: string;
  imgClassName?: string;
}) {
  const [ok, setOk] = useState(true);
  return (
    <div className={`relative overflow-hidden bg-gradient-to-br from-espresso via-espresso-light to-gold-deep ${className}`}>
      {ok && (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          onError={() => setOk(false)}
          className={`h-full w-full object-cover ${imgClassName}`}
        />
      )}
    </div>
  );
}
